import React, {useContext, useEffect} from 'react';
import Typography from '@material-ui/core/Typography';
import {CheckBoxGroup} from '../../../../components/v2';
import {useGetMessages} from '../../../../hooks';
import {useFormContext} from 'react-hook-form';
import {CloseAccountContext} from '../..';
import {HeaderSkeleton} from '../../../../components';
import {PayoutTypes} from '../../../../../shared/types';

export interface DisclaimerProps {
    className?: string;
    amount?: number;
}

export interface DisclaimerFieldValues {
    disclaimerAccepted: boolean;
}

const Disclaimer: React.FC<DisclaimerProps> = ({className}) => {
    const {isRendering, payoutTypeSelected, amount = 0, formattedAmount} = useContext(
        CloseAccountContext
    );
    const methods = useFormContext<DisclaimerFieldValues>();
    const messages = useGetMessages(
        {
            header: 'epic.affiliate.closeAccount.disclaimer.header.v2',
            subHeader: 'epic.affiliate.signup.disclaimer.desc.v2',
            acknowledge: 'epic.affiliate.closeAccount.disclaimer.acknowledge.v2',
            acknowledgeWithPayout: {
                code: 'epic.affiliate.closeAccount.disclaimer.acknowledge.withPayout.v2',
                args: [<strong key="amount">{formattedAmount}</strong>]
            },
            required: 'errors.com.epicgames.validation.required_field.v2'
        },
        [amount]
    );

    useEffect(() => {
        if (payoutTypeSelected) {
            methods.resetField('disclaimerAccepted');
        }
    }, [payoutTypeSelected]);

    return (
        <CheckBoxGroup
            required={!isRendering}
            isRendering={isRendering}
            className={className}
            header={
                isRendering ? (
                    <HeaderSkeleton variant="h5" height={30} width={250} />
                ) : (
                    <Typography variant="h5">{messages.header}</Typography>
                )
            }
            options={[
                {
                    name: 'disclaimerAccepted',
                    control: methods.control,
                    rules: {required: {value: true, message: messages.required}},
                    label: (
                        <Typography color="textSecondary" variant="body2">
                            {payoutTypeSelected === PayoutTypes.CASH
                                ? messages.acknowledgeWithPayout
                                : messages.acknowledge}
                        </Typography>
                    )
                }
            ]}
        />
    );
};

export default Disclaimer;
